@if (!hidden() && (hideGamingCrossSellByArc$ | async) === false) {
    @if (isEpcotEnabled()) {
        <ds-card-header title="{{ model().title }}" msThemedCardHeader surface="lowest" [themedSurface]="themedSurface" (click)="openAll()">
            <vn-icon name="theme-right" slot="title" size="13" />
        </ds-card-header>
    } @else {
        <ds-card-header title="{{ model().title }}" surface="lowest">
            <button slot="end" ds-button variant="outline" kind="tertiary" size="small" (click)="openAll()">
                {{ model().link?.link }}
                <vn-icon slot="end" name="theme-right" size="12" />
            </button>
        </ds-card-header>
    }
    <div class="body">
        @if (ldBannerGamesDisplayType === bannerGamesDisplayType.MultiRow) {
            <ms-banner-games-multi-row [games]="games" [position]="position()" (openGame)="openGame($event)" />
        } @else {
            <ms-banner-games-single-row [games]="games" (openGame)="openGame($event)" />
        }
    </div>
}
